const API_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8080';

/**
 * Fire-and-forget browser error report. Errors here are swallowed — the
 * reporter must never make a broken page worse. keepalive lets the request
 * survive the navigation that often follows a crash.
 */
export function reportClientError(error: unknown, context: string): void {
  try {
    if (typeof window === 'undefined') return;
    const err = error instanceof Error ? error : new Error(String(error));
    void fetch(`${API_URL}/api/v1/client-errors`, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        message: err.message || 'unknown error',
        stack: err.stack?.slice(0, 4000),
        url: window.location.href,
        context,
        user_agent: navigator.userAgent,
        request_id: (err as Error & { requestId?: string }).requestId,
      }),
    }).catch(() => {});
  } catch {
    // never rethrow from the reporter
  }
}
